// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_wapp_svc_comp_kpi.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { grpc } from "@improbable-eng/grpc-web";
import { BrowserHeaders } from "browser-headers";
import { Observable } from "rxjs";
import { take } from "rxjs/operators";
import { GenericPayloadResponse, MultiGenericPayloadResponse } from "./stcs_commons.entity";
import { StcsCompKpiCfg } from "./stcs_comp_kpi_cfg.entity";

export const protobufPackage = "stcs_cmw";

export interface CompKpiCfgActivateRequest {
  ref_id_user: string;
  comp_kpi_cfg: StcsCompKpiCfg | undefined;
}

export interface CompKpiCfgCreateRequest {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
  /** Optional: Limit actuals to this date (format: YYYY-MM). If not provided, uses full actuals range. */
  actuals_end_date_string?:
    | string
    | undefined;
  /** Optional: Reference to a compensation plan configuration to base the KPI config on */
  ref_id_comp_plan_cfg?: string | undefined;
}

export interface CompKpiCfgDelRequest {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
}

export interface CompKpiCfgSaveRequest {
  ref_id_user: string;
  comp_kpi_cfg: StcsCompKpiCfg | undefined;
}

/** Use this for getting a specific KPI config with dynamic actuals range or plan */
export interface CompKpiCfgCalcRequest {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
  /** Optional: Limit actuals to this date (format: YYYY-MM). If not provided, uses full actuals range. */
  actuals_end_date_string?:
    | string
    | undefined;
  /** Optional: Reference to a compensation plan configuration to base the KPI config on */
  ref_id_comp_plan_cfg?: string | undefined;
}

export interface CompKpiCfgListRequest {
  ref_id_comp: string;
  ref_id_org: string;
  ref_id_user: string;
}

export interface CompKpiResValuesGetRequest {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
  /** Optional: Limit actuals to this date (format: YYYY-MM). If not provided, uses full actuals range. */
  actuals_end_date_string?:
    | string
    | undefined;
  /** Optional: Reference to a compensation plan configuration to base the KPI config on */
  ref_id_comp_plan_cfg?: string | undefined;
}

function createBaseCompKpiCfgActivateRequest(): CompKpiCfgActivateRequest {
  return { ref_id_user: "", comp_kpi_cfg: undefined };
}

export const CompKpiCfgActivateRequest: MessageFns<CompKpiCfgActivateRequest> = {
  encode(message: CompKpiCfgActivateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.comp_kpi_cfg !== undefined) {
      StcsCompKpiCfg.encode(message.comp_kpi_cfg, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompKpiCfgActivateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompKpiCfgActivateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.comp_kpi_cfg = StcsCompKpiCfg.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompKpiCfgActivateRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      comp_kpi_cfg: isSet(object.comp_kpi_cfg) ? StcsCompKpiCfg.fromJSON(object.comp_kpi_cfg) : undefined,
    };
  },

  toJSON(message: CompKpiCfgActivateRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.comp_kpi_cfg !== undefined) {
      obj.comp_kpi_cfg = StcsCompKpiCfg.toJSON(message.comp_kpi_cfg);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompKpiCfgActivateRequest>, I>>(base?: I): CompKpiCfgActivateRequest {
    return CompKpiCfgActivateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompKpiCfgActivateRequest>, I>>(object: I): CompKpiCfgActivateRequest {
    const message = createBaseCompKpiCfgActivateRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.comp_kpi_cfg = (object.comp_kpi_cfg !== undefined && object.comp_kpi_cfg !== null)
      ? StcsCompKpiCfg.fromPartial(object.comp_kpi_cfg)
      : undefined;
    return message;
  },
};

function createBaseCompKpiCfgCreateRequest(): CompKpiCfgCreateRequest {
  return {
    ref_id_user: "",
    ref_id_org: "",
    ref_id_comp: "",
    actuals_end_date_string: undefined,
    ref_id_comp_plan_cfg: undefined,
  };
}

export const CompKpiCfgCreateRequest: MessageFns<CompKpiCfgCreateRequest> = {
  encode(message: CompKpiCfgCreateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    if (message.actuals_end_date_string !== undefined) {
      writer.uint32(34).string(message.actuals_end_date_string);
    }
    if (message.ref_id_comp_plan_cfg !== undefined) {
      writer.uint32(42).string(message.ref_id_comp_plan_cfg);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompKpiCfgCreateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompKpiCfgCreateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.actuals_end_date_string = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ref_id_comp_plan_cfg = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompKpiCfgCreateRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      actuals_end_date_string: isSet(object.actuals_end_date_string)
        ? globalThis.String(object.actuals_end_date_string)
        : undefined,
      ref_id_comp_plan_cfg: isSet(object.ref_id_comp_plan_cfg)
        ? globalThis.String(object.ref_id_comp_plan_cfg)
        : undefined,
    };
  },

  toJSON(message: CompKpiCfgCreateRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.actuals_end_date_string !== undefined) {
      obj.actuals_end_date_string = message.actuals_end_date_string;
    }
    if (message.ref_id_comp_plan_cfg !== undefined) {
      obj.ref_id_comp_plan_cfg = message.ref_id_comp_plan_cfg;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompKpiCfgCreateRequest>, I>>(base?: I): CompKpiCfgCreateRequest {
    return CompKpiCfgCreateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompKpiCfgCreateRequest>, I>>(object: I): CompKpiCfgCreateRequest {
    const message = createBaseCompKpiCfgCreateRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.actuals_end_date_string = object.actuals_end_date_string ?? undefined;
    message.ref_id_comp_plan_cfg = object.ref_id_comp_plan_cfg ?? undefined;
    return message;
  },
};

function createBaseCompKpiCfgDelRequest(): CompKpiCfgDelRequest {
  return { ref_id_user: "", ref_id_org: "", ref_id_comp: "" };
}

export const CompKpiCfgDelRequest: MessageFns<CompKpiCfgDelRequest> = {
  encode(message: CompKpiCfgDelRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompKpiCfgDelRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompKpiCfgDelRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompKpiCfgDelRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
    };
  },

  toJSON(message: CompKpiCfgDelRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompKpiCfgDelRequest>, I>>(base?: I): CompKpiCfgDelRequest {
    return CompKpiCfgDelRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompKpiCfgDelRequest>, I>>(object: I): CompKpiCfgDelRequest {
    const message = createBaseCompKpiCfgDelRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    return message;
  },
};

function createBaseCompKpiCfgSaveRequest(): CompKpiCfgSaveRequest {
  return { ref_id_user: "", comp_kpi_cfg: undefined };
}

export const CompKpiCfgSaveRequest: MessageFns<CompKpiCfgSaveRequest> = {
  encode(message: CompKpiCfgSaveRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.comp_kpi_cfg !== undefined) {
      StcsCompKpiCfg.encode(message.comp_kpi_cfg, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompKpiCfgSaveRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompKpiCfgSaveRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.comp_kpi_cfg = StcsCompKpiCfg.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompKpiCfgSaveRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      comp_kpi_cfg: isSet(object.comp_kpi_cfg) ? StcsCompKpiCfg.fromJSON(object.comp_kpi_cfg) : undefined,
    };
  },

  toJSON(message: CompKpiCfgSaveRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.comp_kpi_cfg !== undefined) {
      obj.comp_kpi_cfg = StcsCompKpiCfg.toJSON(message.comp_kpi_cfg);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompKpiCfgSaveRequest>, I>>(base?: I): CompKpiCfgSaveRequest {
    return CompKpiCfgSaveRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompKpiCfgSaveRequest>, I>>(object: I): CompKpiCfgSaveRequest {
    const message = createBaseCompKpiCfgSaveRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.comp_kpi_cfg = (object.comp_kpi_cfg !== undefined && object.comp_kpi_cfg !== null)
      ? StcsCompKpiCfg.fromPartial(object.comp_kpi_cfg)
      : undefined;
    return message;
  },
};

function createBaseCompKpiCfgCalcRequest(): CompKpiCfgCalcRequest {
  return {
    ref_id_user: "",
    ref_id_org: "",
    ref_id_comp: "",
    actuals_end_date_string: undefined,
    ref_id_comp_plan_cfg: undefined,
  };
}

export const CompKpiCfgCalcRequest: MessageFns<CompKpiCfgCalcRequest> = {
  encode(message: CompKpiCfgCalcRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    if (message.actuals_end_date_string !== undefined) {
      writer.uint32(34).string(message.actuals_end_date_string);
    }
    if (message.ref_id_comp_plan_cfg !== undefined) {
      writer.uint32(42).string(message.ref_id_comp_plan_cfg);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompKpiCfgCalcRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompKpiCfgCalcRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.actuals_end_date_string = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ref_id_comp_plan_cfg = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompKpiCfgCalcRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      actuals_end_date_string: isSet(object.actuals_end_date_string)
        ? globalThis.String(object.actuals_end_date_string)
        : undefined,
      ref_id_comp_plan_cfg: isSet(object.ref_id_comp_plan_cfg)
        ? globalThis.String(object.ref_id_comp_plan_cfg)
        : undefined,
    };
  },

  toJSON(message: CompKpiCfgCalcRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.actuals_end_date_string !== undefined) {
      obj.actuals_end_date_string = message.actuals_end_date_string;
    }
    if (message.ref_id_comp_plan_cfg !== undefined) {
      obj.ref_id_comp_plan_cfg = message.ref_id_comp_plan_cfg;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompKpiCfgCalcRequest>, I>>(base?: I): CompKpiCfgCalcRequest {
    return CompKpiCfgCalcRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompKpiCfgCalcRequest>, I>>(object: I): CompKpiCfgCalcRequest {
    const message = createBaseCompKpiCfgCalcRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.actuals_end_date_string = object.actuals_end_date_string ?? undefined;
    message.ref_id_comp_plan_cfg = object.ref_id_comp_plan_cfg ?? undefined;
    return message;
  },
};

function createBaseCompKpiCfgListRequest(): CompKpiCfgListRequest {
  return { ref_id_comp: "", ref_id_org: "", ref_id_user: "" };
}

export const CompKpiCfgListRequest: MessageFns<CompKpiCfgListRequest> = {
  encode(message: CompKpiCfgListRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_comp !== "") {
      writer.uint32(10).string(message.ref_id_comp);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_user !== "") {
      writer.uint32(26).string(message.ref_id_user);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompKpiCfgListRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompKpiCfgListRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompKpiCfgListRequest {
    return {
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
    };
  },

  toJSON(message: CompKpiCfgListRequest): unknown {
    const obj: any = {};
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompKpiCfgListRequest>, I>>(base?: I): CompKpiCfgListRequest {
    return CompKpiCfgListRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompKpiCfgListRequest>, I>>(object: I): CompKpiCfgListRequest {
    const message = createBaseCompKpiCfgListRequest();
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_user = object.ref_id_user ?? "";
    return message;
  },
};

function createBaseCompKpiResValuesGetRequest(): CompKpiResValuesGetRequest {
  return {
    ref_id_user: "",
    ref_id_org: "",
    ref_id_comp: "",
    actuals_end_date_string: undefined,
    ref_id_comp_plan_cfg: undefined,
  };
}

export const CompKpiResValuesGetRequest: MessageFns<CompKpiResValuesGetRequest> = {
  encode(message: CompKpiResValuesGetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    if (message.actuals_end_date_string !== undefined) {
      writer.uint32(34).string(message.actuals_end_date_string);
    }
    if (message.ref_id_comp_plan_cfg !== undefined) {
      writer.uint32(42).string(message.ref_id_comp_plan_cfg);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompKpiResValuesGetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompKpiResValuesGetRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.actuals_end_date_string = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ref_id_comp_plan_cfg = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompKpiResValuesGetRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      actuals_end_date_string: isSet(object.actuals_end_date_string)
        ? globalThis.String(object.actuals_end_date_string)
        : undefined,
      ref_id_comp_plan_cfg: isSet(object.ref_id_comp_plan_cfg)
        ? globalThis.String(object.ref_id_comp_plan_cfg)
        : undefined,
    };
  },

  toJSON(message: CompKpiResValuesGetRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.actuals_end_date_string !== undefined) {
      obj.actuals_end_date_string = message.actuals_end_date_string;
    }
    if (message.ref_id_comp_plan_cfg !== undefined) {
      obj.ref_id_comp_plan_cfg = message.ref_id_comp_plan_cfg;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompKpiResValuesGetRequest>, I>>(base?: I): CompKpiResValuesGetRequest {
    return CompKpiResValuesGetRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompKpiResValuesGetRequest>, I>>(object: I): CompKpiResValuesGetRequest {
    const message = createBaseCompKpiResValuesGetRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.actuals_end_date_string = object.actuals_end_date_string ?? undefined;
    message.ref_id_comp_plan_cfg = object.ref_id_comp_plan_cfg ?? undefined;
    return message;
  },
};

export interface StcsWappSvcCompKpi {
  comp_kpi_cfg_create(
    request: DeepPartial<CompKpiCfgCreateRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse>;
  comp_kpi_cfg_calc(
    request: DeepPartial<CompKpiCfgCalcRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse>;
  comp_kpi_cfg_save(
    request: DeepPartial<CompKpiCfgSaveRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  comp_kpi_res_values_get(
    request: DeepPartial<CompKpiResValuesGetRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
}

export class StcsWappSvcCompKpiClientImpl implements StcsWappSvcCompKpi {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.comp_kpi_cfg_create = this.comp_kpi_cfg_create.bind(this);
    this.comp_kpi_cfg_calc = this.comp_kpi_cfg_calc.bind(this);
    this.comp_kpi_cfg_save = this.comp_kpi_cfg_save.bind(this);
    this.comp_kpi_res_values_get = this.comp_kpi_res_values_get.bind(this);
  }

  comp_kpi_cfg_create(
    request: DeepPartial<CompKpiCfgCreateRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcCompKpicomp_kpi_cfg_createDesc,
      CompKpiCfgCreateRequest.fromPartial(request),
      metadata,
    );
  }

  comp_kpi_cfg_calc(
    request: DeepPartial<CompKpiCfgCalcRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcCompKpicomp_kpi_cfg_calcDesc,
      CompKpiCfgCalcRequest.fromPartial(request),
      metadata,
    );
  }

  comp_kpi_cfg_save(
    request: DeepPartial<CompKpiCfgSaveRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcCompKpicomp_kpi_cfg_saveDesc,
      CompKpiCfgSaveRequest.fromPartial(request),
      metadata,
    );
  }

  comp_kpi_res_values_get(
    request: DeepPartial<CompKpiResValuesGetRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcCompKpicomp_kpi_res_values_getDesc,
      CompKpiResValuesGetRequest.fromPartial(request),
      metadata,
    );
  }
}

export const StcsWappSvcCompKpiDesc = { serviceName: "stcs_cmw.StcsWappSvcCompKpi" };

export const StcsWappSvcCompKpicomp_kpi_cfg_createDesc: UnaryMethodDefinitionish = {
  methodName: "comp_kpi_cfg_create",
  service: StcsWappSvcCompKpiDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return CompKpiCfgCreateRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = MultiGenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcCompKpicomp_kpi_cfg_calcDesc: UnaryMethodDefinitionish = {
  methodName: "comp_kpi_cfg_calc",
  service: StcsWappSvcCompKpiDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return CompKpiCfgCalcRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = MultiGenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcCompKpicomp_kpi_cfg_saveDesc: UnaryMethodDefinitionish = {
  methodName: "comp_kpi_cfg_save",
  service: StcsWappSvcCompKpiDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return CompKpiCfgSaveRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcCompKpicomp_kpi_res_values_getDesc: UnaryMethodDefinitionish = {
  methodName: "comp_kpi_res_values_get",
  service: StcsWappSvcCompKpiDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return CompKpiResValuesGetRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

interface UnaryMethodDefinitionishR extends grpc.UnaryMethodDefinition<any, any> {
  requestStream: any;
  responseStream: any;
}

type UnaryMethodDefinitionish = UnaryMethodDefinitionishR;

interface Rpc {
  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Observable<any>;
}

export class GrpcWebImpl {
  private host: string;
  private options: {
    transport?: grpc.TransportFactory;

    debug?: boolean;
    metadata?: grpc.Metadata;
    upStreamRetryCodes?: number[];
  };

  constructor(
    host: string,
    options: {
      transport?: grpc.TransportFactory;

      debug?: boolean;
      metadata?: grpc.Metadata;
      upStreamRetryCodes?: number[];
    },
  ) {
    this.host = host;
    this.options = options;
  }

  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Observable<any> {
    const request = { ..._request, ...methodDesc.requestType };
    const maybeCombinedMetadata = metadata && this.options.metadata
      ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
      : metadata ?? this.options.metadata;
    return new Observable((observer) => {
      grpc.unary(methodDesc, {
        request,
        host: this.host,
        metadata: maybeCombinedMetadata ?? {},
        ...(this.options.transport !== undefined ? { transport: this.options.transport } : {}),
        debug: this.options.debug ?? false,
        onEnd: (next) => {
          if (next.status !== 0) {
            const err = new GrpcWebError(next.statusMessage, next.status, next.trailers);
            observer.error(err);
          } else {
            observer.next(next.message as any);
            observer.complete();
          }
        },
      });
    }).pipe(take(1));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export class GrpcWebError extends globalThis.Error {
  constructor(message: string, public code: grpc.Code, public metadata: grpc.Metadata) {
    super(message);
  }
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
